<template>
  <div class="q-page">
    <div class="container py-5">

      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb q-breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Inicio</router-link></li>
          <li class="breadcrumb-item active">¿Cómo comprar?</li>
        </ol>
      </nav>

      <div class="row justify-content-center">
        <div class="col-lg-8">
          <p class="q-section-title mb-4">¿Cómo comprar?</p>

          <div class="q-steps">

            <div class="q-step">
              <div class="q-step__number">01</div>
              <div class="q-step__content">
                <h2 class="q-step__title">Explorá el catálogo</h2>
                <p>Navegá por nuestras categorías o usá el buscador para encontrar el producto que necesitás. Podés filtrar por marca, categoría o precio para refinar los resultados.</p>
              </div>
            </div>

            <div class="q-step">
              <div class="q-step__number">02</div>
              <div class="q-step__content">
                <h2 class="q-step__title">Agregá al carrito</h2>
                <p>Al encontrar el producto, seleccioná la variante deseada (si aplica) y hacé click en "Agregar al carrito". Podés continuar comprando y agregar más productos antes de finalizar.</p>
              </div>
            </div>

            <div class="q-step">
              <div class="q-step__number">03</div>
              <div class="q-step__content">
                <h2 class="q-step__title">Revisá tu carrito</h2>
                <p>Accedé al carrito desde el ícono en el encabezado. Allí podés revisar los productos seleccionados, modificar cantidades o eliminar artículos antes de continuar.</p>
              </div>
            </div>

            <div class="q-step">
              <div class="q-step__number">04</div>
              <div class="q-step__content">
                <h2 class="q-step__title">Completá tus datos</h2>
                <p>Ingresá tus datos de contacto y dirección de entrega. Podés registrarte para guardar tu información para futuras compras o continuar como invitado.</p>
              </div>
            </div>

            <div class="q-step">
              <div class="q-step__number">05</div>
              <div class="q-step__content">
                <h2 class="q-step__title">Elegí el método de pago</h2>
                <p>Seleccioná el medio de pago de tu preferencia. Aceptamos tarjetas de crédito, débito y transferencia bancaria. El proceso es seguro y encriptado.</p>
              </div>
            </div>

            <div class="q-step q-step--last">
              <div class="q-step__number">06</div>
              <div class="q-step__content">
                <h2 class="q-step__title">¡Listo! Confirmá tu pedido</h2>
                <p>Una vez confirmado el pago, recibirás un correo con el detalle de tu pedido. Nos pondremos en contacto para coordinar la entrega o retiro.</p>
              </div>
            </div>

          </div>

          <div class="q-help-box mt-5">
            <i class="bi bi-headset q-help-box__icon"></i>
            <div>
              <p class="q-help-box__title">¿Tenés dudas?</p>
              <p class="q-help-box__text">Nuestro equipo está disponible para ayudarte en cada paso del proceso.</p>
              <router-link :to="{ name: 'Contact' }" class="btn btn-primary btn-sm mt-2">Contactanos</router-link>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "HowToBuy",
};
</script>

<style scoped>
.q-breadcrumb { background: transparent; padding: 0; margin: 0; }
.q-breadcrumb .breadcrumb-item { font-size: 14px; color: var(--q-text-subtle); }
.q-breadcrumb .breadcrumb-item a { color: var(--q-text-muted); }
.q-breadcrumb .breadcrumb-item a:hover { color: var(--primary-color); }
.q-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: var(--q-text-subtle); }

/* Steps */
.q-steps { display: flex; flex-direction: column; }

.q-step {
  display: flex;
  gap: 20px;
  padding-bottom: 2rem;
  position: relative;
}
.q-step:not(.q-step--last)::before {
  content: '';
  position: absolute;
  left: 19px;
  top: 44px;
  bottom: 0;
  width: 1px;
  background-color: var(--q-border);
}

.q-step__number {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: #fff;
  font-family: var(--q-font-mono);
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.05em;
  z-index: 1;
}

.q-step__content { padding-top: 8px; }

.q-step__title {
  font-family: var(--q-font-display);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--q-text);
  margin-bottom: 6px;
}

.q-step__content p {
  font-size: 14px;
  line-height: 1.8;
  color: var(--q-text-muted);
  margin: 0;
}

/* Help box */
.q-help-box {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background-color: var(--q-bg-elevated);
  border: 1px solid var(--q-border);
  border-left: 3px solid var(--primary-color);
  border-radius: var(--q-radius);
  padding: 20px 24px;
}
.q-help-box__icon {
  font-size: 28px;
  color: var(--primary-color);
  flex-shrink: 0;
  margin-top: 2px;
}
.q-help-box__title {
  font-family: var(--q-font-display);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--q-text);
  margin: 0 0 4px;
}
.q-help-box__text {
  font-size: 13px;
  color: var(--q-text-muted);
  margin: 0;
}
</style>
